"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dropzone_1 = require("react-dropzone");
var react_i18next_1 = require("react-i18next");
var BuildingMediaUploadIcon_1 = __importDefault(require("../../../Icons/BuildingMediaUploadIcon"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var baseStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer',
};
var activeStyle = {
    borderColor: '#2196f3',
};
var acceptStyle = {
    borderColor: '#00e676',
};
var rejectStyle = {
    borderColor: '#ff1744',
};
var DropZone = function (_a) {
    var handleDropZoneChange = _a.handleDropZoneChange;
    var _b = react_dropzone_1.useDropzone({
        onDrop: function (acceptedFiles) {
            onAdd(acceptedFiles);
        },
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, isDragActive = _b.isDragActive, isDragAccept = _b.isDragAccept, isDragReject = _b.isDragReject;
    var t = react_i18next_1.useTranslation('common').t;
    var style = react_1.useMemo(function () { return (__assign(__assign(__assign(__assign({}, baseStyle), (isDragActive ? activeStyle : {})), (isDragAccept ? acceptStyle : {})), (isDragReject ? rejectStyle : {}))); }, [isDragActive, isDragReject, isDragAccept]);
    var onAdd = function (files) {
        handleDropZoneChange(files);
    };
    return (react_1.default.createElement("section", null,
        react_1.default.createElement("div", __assign({}, getRootProps({ style: style })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("input", __assign({}, getInputProps(), { className: styles_module_scss_1.default.file_input }))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(BuildingMediaUploadIcon_1.default, null)),
            react_1.default.createElement("p", { className: styles_module_scss_1.default.text }, t('fields.section4.file_upload.drag_n_drop')))));
};
exports.default = DropZone;
